// extracted by mini-css-extract-plugin
export default {"hidden":"downloadRetentionCertificatePDFModal_hidden__zAMcw"};